/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionClientsGet } from "../funcs/userSessionClientsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionClient } from "../models/components/usersessionclient.js";
import {
  GetUserSessionClientRequest,
  GetUserSessionClientSecurity,
} from "../models/operations/getusersessionclient.js";
import { unwrapAsync } from "../types/fp.js";
export type UserSessionClientQueryData = UserSessionClient;

export function prefetchUserSessionClient(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetUserSessionClientRequest,
  security?: GetUserSessionClientSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionClientQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildUserSessionClientQuery(
  client$: GramCore,
  request: GetUserSessionClientRequest,
  security?: GetUserSessionClientSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionClientQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionClient({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function userSessionClientQueryFn(
      ctx,
    ): Promise<UserSessionClientQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionClientsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyUserSessionClient(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionClients", "get", parameters];
}
